import {PANELMANAGER_HIDE_DELETESUCCESSDIALOG} from '../../constants';

export type HideDeleteSuccessDialogAction = {
    type : typeof PANELMANAGER_HIDE_DELETESUCCESSDIALOG;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {HideDeleteSuccessDialogAction}
 */
export default function hideDeleteSuccessDialog( panelKey : string ) : HideDeleteSuccessDialogAction {
    return {
        type: PANELMANAGER_HIDE_DELETESUCCESSDIALOG,
        panelKey
    };
}
